var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4,
    x2: 28,
    y1: 31,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007c3c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78fc4e",
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_libreoffice_calc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.875 0 0 .875 2 2)",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 0c-2.216 0-4 1.784-4 4v24c0 2.216 1.784 4 4 4h18c2.216 0 4-1.784 4-4v-16l-12-12zm13 0 9 9v-9z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 27v1c0 2.216 1.784 4 4 4h18c2.216 0 4-1.784 4-4v-1c0 2.216-1.784 4-4 4h-18c-2.216 0-4-1.784-4-4z",
    fillOpacity: 0.19862
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 0h1.4l7.6 7.6v1.4z",
    fillOpacity: 0.20149
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 13c-0.554 0-1 0.446-1 1v7c0 0.554 0.446 1 1 1h6v-1h-2v-1h2v-1h-2v-1h8v-4c0-0.554-0.446-1-1-1zm0 1h3v1h-3zm4 0h3v1h-3zm4 0h3v1h-3zm-8 2h3v1h-3zm4 0h3v1h-3zm4 0h3v1h-3zm-8 2h3v1h-3zm0 2h3v1h-3z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 18c-0.554 0-1 0.446-1 1v5c0 0.554 0.446 1 1 1h7c0.554 0 1-0.446 1-1v-5c0-0.554-0.446-1-1-1zm2 1h1v5h-1zm-2 1h1v4h-1zm6 1h1v3h-1zm-2 1h1v2h-1z",
    fill: "#b4f48b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOds);
export default __webpack_public_path__ + "static/media/ods.2750370a608e251b146292d7687bd02c.svg";
export { ForwardRef as ReactComponent };